export default __webpack_public_path__ + "static/media/circulo_información.e9424231.svg";